module.exports = __webpack_public_path__ + "img/login_avatar.5bbe127a.png";